import { render, staticRenderFns } from "./EmployeeCohortAddEdit.vue?vue&type=template&id=4fb4b431"
import script from "./EmployeeCohortAddEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeCohortAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports